import {mapActions, mapGetters} from "vuex";
import Utils from "@/services/utils";


export const setSprData = {
    data() {
        return {
            filter: {
                sprUsl: [],
                sprFo: [],
                sprFf: []
            },
            allowedUslList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            allowedFoList: [1, 2, 3],
            allowedFfList: [1, 2, 3], //4  = по договорам об оказании платных образовательных услуг
            allowedUslForUgsList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        }
    },
    computed: {
        ...mapGetters('keycloak', {
            getUserRoles: 'getUserRoles',
            getUser: 'getUser',
            isAdmin: 'isAdmin',
            getFakeUser: 'getFakeUser',
            getIdUser: 'getIdUser'
        }),
        ...mapGetters('checkFilled', {getBlock: 'getBlockStatus', checkCanBlock: 'getBlockStatusEdit'}),
        ...mapGetters('spr', {
            getSprData: 'getSprData',
            getSprDataLoading: 'getSprDataLoading',
            getSprDataError: 'getSprDataError'
        }),
        sprData() {
            return {
                sprOrg: Utils.mapSpr(this.getSprData.org
                    .filter(el => el.ownerId === this.getUser.orgID || el.ownerId === this.getFakeUser?.id), 'id', (el) => el.name),
                sprKcpGroup: this.getSprData.kcpgroup.filter((el) => {
                    return this.allowedUslForUgsList.includes(el.usl.id)
                }),
                sprUsl: Utils.mapSpr(this.getSprData.usl.filter(el => (this.allowedUslList.includes(el.id))), 'id', (el) => el.name),
                sprFo: Utils.mapSpr(this.getSprData.fo.filter(el => (this.allowedFoList.includes(el.id))), 'id', (el) => el.name),
                sprFf: Utils.mapSpr(this.getSprData.ff.filter(el => this.allowedFfList.includes(el.id)), 'id', (el) => el.name)
            }
        },
        filteredData() {
            return this.tableData.data?.filter(el => this.filter.sprUsl.includes(el.usl.id) && this.filter.sprFo.includes(el.foId) && this.filter.sprFf.includes(el.ffId)) ?? []
        },
        sprLoadingFilter() {
            return this.getSprDataLoading.fo || this.getSprDataLoading.ff || this.getSprDataLoading.usl || this.getSprDataLoading.kcpgroup
        }
    },
    watch: {
        sprLoadingFilter(v) {
            if (!v)
                this.initFilterValues()
        }
    },
    created() {
        if (!this.sprLoadingFilter)
            this.initFilterValues()
    },
    methods: {
        ...mapActions('notification', {addNotification: 'setNotification'}),
        ...mapActions('checkFilled', {checkBlockOneType: 'checkBlockOneType', blockOneType: 'blockOneType'}),
        paintBackgroundProp(row) {
            return () => {
                if (row.sumPlaces !== row.value) return 'yellow-background';
                else
                    return ''
            };
        },
        canDeleteRow(row){
          return row.ffId > 1 || (row.value === 0 && row.ffId === 1 && row.orgId !==  this.getIdUser)
        },
        initFilterValues() {
            this.sprData.sprUsl.forEach(el => this.filter.sprUsl.push(el.value));
            this.sprData.sprFf.forEach(el => this.filter.sprFf.push(el.value));
            this.sprData.sprFo.forEach(el => this.filter.sprFo.push(el.value));
        },
        async blockData() {
            if (this.checkCanBlock[this.type].value) {
                await this.blockOneType({value: true, type: this.type});
            } else {
                this.errorMessages = this.checkCanBlock[this.type].messages;
                this.showErrorModal = true;
            }
        },
        async blockDataCk() {
            if (this.checkCanBlock[`TARGET_QUOTA_${this.type}`].value) {
                await this.blockOneType({value: true, type: `TARGET_QUOTA_${this.type}`});
            } else {
                this.errorMessages = this.checkCanBlock[`TARGET_QUOTA_${this.type}`].messages;
                this.showErrorModal = true;
            }
        },
        async blockDataDvi() {
            if (this.checkCanBlock[`DVI_NUMBER`].value) {
                await this.blockOneType({value: true, type: `DVI_NUMBER`});
            } else {
                this.errorMessages = this.checkCanBlock[`DVI_NUMBER`].messages;
                this.showErrorModal = true;
            }
        },
    }
}